import { Button } from "@/components/ui/button"
import { ArrowRight } from "lucide-react"
import { Link } from "react-router-dom"
import { useInView } from "@/hooks/use-in-view"

export function DemoBanner() {
	const { ref, inView } = useInView()

	return (
		<div ref={ref} className={`transition-opacity duration-700 ease-out ${inView ? "opacity-100" : "opacity-0"}`}>
			<section className="py-20 px-4">
				<div className="max-w-3xl mx-auto">
					<div className="rounded-3xl p-10 sm:p-14 text-center border border-sky-300/30 dark:border-sky-600/20 bg-gradient-to-br from-sky-600 to-sky-700 dark:from-sky-700 dark:to-sky-900 shadow-[0_20px_60px_-15px_rgba(14,165,233,0.4)]">
						<h2 className="text-2xl sm:text-3xl font-bold text-white">Try Before You Sign Up</h2>
						<p className="mt-3 text-base sm:text-lg text-sky-100/80">
							Fully functional sandbox with real stock data. No account needed.
						</p>
						<div className="mt-8">
							<Link to="/demo">
								<Button
									size="lg"
									className="font-bold text-base h-12 px-8 rounded-full bg-white text-sky-700 hover:bg-sky-50 shadow-lg transition-all hover:scale-105"
								>
									Launch Demo <ArrowRight className="ml-2 h-5 w-5" />
								</Button>
							</Link>
						</div>
					</div>
				</div>
			</section>
		</div>
	)
}
